/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetFragmentDetailByIdQueryResponse, GetFragmentDetailByIdPathParams, GetFragmentDetailById404 } from "../models/GetFragmentDetailById";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getFragmentDetailById } from "../axios/getFragmentDetailById";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getFragmentDetailByIdQueryKey = (id: GetFragmentDetailByIdPathParams["id"]) => ["web-app-bff-api", { url: '/fragments/:id', params: {id:id} }] as const

export type GetFragmentDetailByIdQueryKey = ReturnType<typeof getFragmentDetailByIdQueryKey>

export function getFragmentDetailByIdQueryOptions(id: GetFragmentDetailByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getFragmentDetailByIdQueryKey(id)
        return queryOptions<GetFragmentDetailByIdQueryResponse, ResponseErrorConfig<GetFragmentDetailById404>, GetFragmentDetailByIdQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getFragmentDetailById(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get one fragment by id
 * {@link /fragments/:id}
 */
export function useGetFragmentDetailById<TData = GetFragmentDetailByIdQueryResponse, TQueryData = GetFragmentDetailByIdQueryResponse, TQueryKey extends QueryKey = GetFragmentDetailByIdQueryKey>(id: GetFragmentDetailByIdPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<GetFragmentDetailByIdQueryResponse, ResponseErrorConfig<GetFragmentDetailById404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getFragmentDetailByIdQueryKey(id)
         

         const query = useQuery({
          ...getFragmentDetailByIdQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetFragmentDetailById404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}